export const COLORS = {
  primary: '#000066',
  secondary: '#ff7e00',
  background: '#fff2e6',
  electricity: '#FFD700',
  gas: '#00CCFF',
  water: '#00A86B',
  waterCold: '#00A86B',
  waterWarm: '#FF6B6B',
  danger: '#ef4444',
  success: '#22c55e'
};

export const GAS_DEFAULTS = {
  zNumber: 1.0,
  heatingValue: 10.0
};

// Alte AD_CONFIG für Kompatibilität beibehalten, aber deprecated
export const AD_CONFIG = {
  link: 'https://meinerfahrungsbericht.de/tools/energie-monitor/energie-monitor-app/index.html',
  text: 'Tarife jetzt vergleichen'
};

// Import zentrale Links
import { LINKS } from '../config/links';

// Re-export für einfachen Zugriff
export const REMINDER_APP_URL = LINKS.REMINDER_URL;
export const LOGO_URL = LINKS.LOGO_URL;
export const SITE_NAME = LINKS.SITE_NAME;
export const APP_NAME = LINKS.APP_NAME;